import { defineMessages } from 'react-intl-next';
/* @todo when platformized carousel extension,
 * rename the id to something along the lines of company-hub.carousel-extension.navigation-thumbnail.placeholder.title
 * and modify the description
 */
export const messages: {
	emptyStatePlaceholderTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStatePlaceholderTitle: {
		id: 'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title',
		defaultMessage: 'Add a title',
		description:
			'Placeholder title that is displayed in extra small frame when no title is provided',
	},
});
